import React, { useState, useEffect } from 'react'
import { Box, TextInput, Flex, Group, Button } from '@mantine/core'
import { validation } from '../../../../../plugins/validation'
import { updateOrderInvoiceNumber } from '../../../../../services/orders'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  invoice_number: '',
  tracking_code: '',
  courier_name: ''
}

const formValidation = {
  invoice_number: {
    isError: false,
    message: ''
  },
}

const FormAdjustInvoiceNumber = ({ dataInvoice, onCloseForm, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitInvoiceNumber = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      invoice_number: form.invoice_number,
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      invoice_number: form.invoice_number,
      tracking_code: form.tracking_code,
      courier_name: form.courier_name
    }
    try {
      const response = await updateOrderInvoiceNumber(dataInvoice.id, payload)
      if (response.success) {
        onCloseForm()
        reloadList()
        notificationSuccess('Update Invoice Number Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Invoice Number Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataInvoice) {
      handleSetForm(dataInvoice)
    }
  }, [dataInvoice])

  const handleSetForm = (value) => {
    const dataDetail = {
      invoice_number: value.invoice_code,
      tracking_code: value.tracking_code,
      courier_name: value.courier_name
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='sm'>
        <TextInput
          name='invoice_number'
          value={formData.invoice_number}
          label='Invoice Number'
          placeholder='Input invoice number'
          onChange={(val) => handleChangeForm('invoice_number', val.target.value)}
          error={validationForm.invoice_number.isError ? `${validationForm.invoice_number.message}` : ''}
          withAsterisk
          size='xs'
        />
      </Box>
      <Box mb='sm'>
        <TextInput
          name='tracking_code'
          value={formData.tracking_code}
          label='Tracking Code'
          placeholder='Input tracking code'
          onChange={(val) => handleChangeForm('tracking_code', val.target.value)}
          size='xs'
        />
      </Box>
      <Box mb='sm'>
        <TextInput
          name='courier_name'
          value={formData.courier_name}
          label='Courier Name'
          placeholder='Input courier name'
          onChange={(val) => handleChangeForm('courier_name', val.target.value)}
          size='xs'
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitInvoiceNumber(formData)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustInvoiceNumber